module.exports = __webpack_public_path__ + "img/body_left.6dc1d305.png";